import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  DosisSection,
  Products,
  Bonificacion,
  ValueAdd,
  InvestmentSummary,
  AreYouReady,
} from './components';

const LandingMediaKitLacteosBarinas = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <DosisSection />
      </Container>
      <Container>
        <Products />
      </Container>
      <Container>
        <Bonificacion />
      </Container>
      <Container>
        <ValueAdd />
      </Container>
      <Container>
        <InvestmentSummary />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitLacteosBarinas.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitLacteosBarinas;
